"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var OWNER_URI = 'owners/v2/owners';

var OwnersAPI =
/*#__PURE__*/
function () {
  function OwnersAPI() {
    (0, _classCallCheck2.default)(this, OwnersAPI);
  }

  (0, _createClass2.default)(OwnersAPI, null, [{
    key: "getOwners",
    value: function getOwners(_ref) {
      var includeInactive = _ref.includeInactive,
          offset = _ref.offset;
      return _apiClient.default.get(OWNER_URI, {
        query: {
          portalId: _hubspot.default.get(),
          contactsOnly: true,
          includeInactive: includeInactive,
          offset: offset
        }
      });
    }
  }]);
  return OwnersAPI;
}();

exports.default = OwnersAPI;
module.exports = exports.default;